import * as React from "react";
import { FormGroup, Checkbox, FormControlLabel } from "@mui/material";

export default function CheckboxLabels(props) {
  let { label, checked, onChange, id, value, disabled } = props;
  return (
    <FormGroup>
      <FormControlLabel
        control={
          <Checkbox
            style={{
              color: `${checked ? "#007E8C" : "#DCDCDC"}`,
            }}
          />
        }
        label={
          <span className="text-[#333333] ml-2 font-bold text-lg">{label}</span>
        }
        onChange={onChange}
        id={id}
        value={value}
        checked={checked}
        disabled={disabled}
      />
    </FormGroup>
  );
}
